import { memo, ReactElement } from 'react';
import ResidenceOriginComponent from 'practice/components/edit/form/shared/residence-origin';
import { useFormikContext } from 'formik';
import { NewPersonVM } from 'shell/components/shared/sipo-person-form/new-person';
import { DateTime } from 'luxon';
import { useEventCallback } from '@mui/material';
import { ResidenceOrigin as ResidenceOriginType } from 'shell/view-models/personal-data';

interface ActiveStepProps {
  step?: number;
  isEdit?: boolean;
  typeRegister?: string;
}
const ResidenceOriginComp = ({ isEdit, typeRegister }: ActiveStepProps): ReactElement => {
  const formContext = useFormikContext<NewPersonVM>();

  const onChangeResidence = useEventCallback(
    (key: keyof ResidenceOriginType, value: ResidenceOriginType[keyof ResidenceOriginType]) => {
      formContext.setValues({
        ...(formContext.values || {}),
        residenceOrigin: {
          ...(formContext.values?.residenceOrigin || {}),
          [key]: value,
        },
      });
    }
  );

  const onChangeValuesResidence = useEventCallback((values: ResidenceOriginType) => {
    formContext.setValues({
      ...(formContext.values || {}),
      residenceOrigin: {
        ...(formContext.values?.residenceOrigin || {}),
        ...values,
      },
    });
  });

  return (
    <ResidenceOriginComponent
      onChange={onChangeResidence}
      onChangeValues={onChangeValuesResidence}
      disabled={!isEdit}
      typeRegister={typeRegister}
      fromDate={DateTime.now()}
      values={formContext.values?.residenceOrigin}
    />
  );
};

ResidenceOriginComp.displayName = 'Residence Origin Comp new person';

const ResidenceOrigin = memo(ResidenceOriginComp) as typeof ResidenceOriginComp;

export default ResidenceOrigin;
